var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"my-2",attrs:{"nuxtlink":"","link":"/investing/services/mobile-app"}},[_vm._v(_vm._s(_vm.$t('global.buttons.mobileapp')))])
}
var staticRenderFns = []

export { render, staticRenderFns }